export enum EstadoNavegacaoUnidadesEnum {
    PRIMEIRO = 'PRIMEIRO',
    ULTIMO = 'ULTIMO',
    PROXIMO = 'PROXIMO',
    ANTERIOR = 'ANTERIOR',
}
